var _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconCloseChat = function SvgIconCloseChat(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_440_1230)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.4754,
    cy: 16.5,
    rx: 7.52459,
    ry: 7.5,
    fill: "#D62E4F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_440_1230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7496 24.9233C28.2629 25.4367 29.0796 25.3667 29.5579 24.83C30.7829 23.4533 32.5096 22.5667 34.4929 22.45C37.2229 22.2867 39.4279 23.3833 41.0496 25.705C42.1463 27.28 42.3096 29.065 42.2513 30.6983H42.2046C41.6213 30.6983 41.2129 31.0017 41.0496 31.55C40.9913 31.7367 40.9679 31.935 40.9679 32.1683V37.6517C40.9679 37.9667 41.0846 38.2583 41.3063 38.48L44.4213 41.385C44.5379 41.2217 44.6313 41.2567 44.7246 41.0817C46.3579 40.8483 47.2679 39.81 47.2679 38.1533V37.5817C47.2679 36.52 47.2679 35.4583 47.2679 34.4083C47.2679 32.8333 45.9263 31.305 44.6663 30.6867C44.7363 30.8733 44.6663 30.3717 44.6896 30.0567C44.6896 29.4033 44.6779 28.7267 44.5379 28.0617C43.7679 24.0833 41.3763 21.47 37.4446 20.315C37.0363 20.1983 36.6279 20.14 36.2313 20.0817C36.0563 20.0583 35.8929 20.035 35.7179 20H34.2946L34.1079 20.035C33.1046 20.1167 32.1596 20.3383 31.3079 20.7117C29.8496 21.3417 28.6596 22.1933 27.7146 23.2433C27.2713 23.7333 27.2829 24.48 27.7496 24.9467V24.9233ZM43.4296 33.16C43.7213 33.16 44.0129 33.16 44.2579 33.1833C44.2813 33.1833 44.3863 33.2533 44.5379 33.44C44.7246 33.6733 44.8179 33.9767 44.8179 34.3383V38.165C44.8179 38.5733 44.7246 38.6783 44.3046 38.725C44.2346 38.725 44.1646 38.725 44.0596 38.725H43.4296V33.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3379 41.8166C39.9179 41.9916 39.4979 42.1083 39.1596 42.1199C38.5062 40.2416 36.6746 39.4133 35.1812 39.5999C33.2446 39.8449 31.8446 41.4083 31.8329 43.3216C31.8329 45.1883 33.2796 46.7983 35.2046 47.0549C35.3679 47.0783 35.5196 47.0899 35.6829 47.0899C37.2112 47.0899 38.5646 46.0983 39.1596 44.5349C40.2212 44.4649 41.2362 44.1616 42.1579 43.6483L40.3379 41.8283V41.8166ZM36.5462 44.2433C36.3012 44.4883 35.9862 44.6283 35.6479 44.6283C34.9246 44.6283 34.3062 43.9983 34.3062 43.2866C34.3062 42.5866 34.8896 42.0033 35.6012 42.0033C36.3596 42.0033 36.9079 42.5749 36.9079 43.3566C36.9079 43.6833 36.7796 43.9983 36.5462 44.2433Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9396 31.795C28.8462 31.1066 28.3679 30.6983 27.6796 30.6983H27.6562V30.4416C27.6562 30.01 27.6796 29.6016 27.7029 29.205L25.6029 27.105C25.5329 27.3616 25.4512 27.6183 25.3929 27.8866C25.2179 28.7383 25.2179 29.5783 25.2179 30.395V30.7216C24.5296 30.7683 23.8762 31.0483 23.3629 31.5383C22.7446 32.1216 22.3596 32.9616 22.3479 33.7783C22.3129 35.4233 22.3129 36.8816 22.3479 38.235C22.3829 39.81 23.6546 41.0933 25.2412 41.1633C25.8362 41.1866 26.4196 41.1866 27.0146 41.1866H27.6446C28.4729 41.1866 28.9512 40.7083 28.9512 39.8683V32.1916C28.9512 32.0633 28.9512 31.935 28.9279 31.8066L28.9396 31.795ZM26.5012 38.7133C26.0929 38.7133 25.6962 38.725 25.3112 38.7016C25.0196 38.6783 24.7979 38.3983 24.7979 38.0716C24.7979 36.695 24.7979 35.33 24.7979 33.9533C24.7979 33.44 25.0896 33.1483 25.6146 33.1483H26.5012V38.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8704 40.7798L41.9583 37.8677C41.817 37.7264 41.588 37.7264 41.4468 37.8677L41.323 37.9914C41.1818 38.1327 41.1818 38.3617 41.323 38.5029L44.2351 41.415C44.3764 41.5562 44.6054 41.5562 44.7466 41.415L44.8704 41.2913C45.0116 41.15 45.0116 40.921 44.8704 40.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3895 47.0317C45.0862 47.0317 44.7945 46.915 44.5612 46.6933L21.5079 23.6283C21.0529 23.1733 21.0529 22.4383 21.5079 21.9833C21.9629 21.5283 22.6979 21.5283 23.1529 21.9833L46.2179 45.0367C46.6729 45.4917 46.6729 46.2267 46.2179 46.6817C45.9845 46.915 45.6929 47.02 45.3895 47.02V47.0317Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_440_1230",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.2 0 0 0 0 0.286275 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_1230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_1230",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_440_1230",
    x: 35.9508,
    y: 0,
    width: 35.0492,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.180392 0 0 0 0 0.309804 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_1230"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_1230",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_440_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(20 20)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCloseChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-close-chat.499f9077.svg";
export { ForwardRef as ReactComponent };